import { simpleStringHash } from "@mw/shared/hash";

import { AGENT_ORB_TEXTURE_NAMES } from "./textures";

export function getAgentOrbTexture(slug: string | null | undefined) {
  const fallbackTexture = AGENT_ORB_TEXTURE_NAMES[0] ?? "agents-1";

  if (AGENT_ORB_TEXTURE_NAMES.length === 0) {
    return fallbackTexture;
  }

  const textureIndex = Math.abs(simpleStringHash(slug ?? "agent-orb")) % AGENT_ORB_TEXTURE_NAMES.length;
  return AGENT_ORB_TEXTURE_NAMES[textureIndex] ?? fallbackTexture;
}
